export type SpecificallyAuditDataRequestBody = {
  vehicleIds: Array<string>;
  keys: Array<string>;
};
